import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import stl from "./CarMakeContainer.module.css";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import useHelpers from "@hooks/useHelpers";
import { ucWords } from "@/utils/stringHelpers";
var CarMakeContainer = function CarMakeContainer(props) {
  var _props$models, _props$carMakesOrMode, _props$carMakesOrMode2, _props$carMakesOrMode3, _props$carMakesOrMode4, _props$carMakesOrMode5, _props$carMakesOrMode6;
  var title = props.title,
    cta = props.cta,
    _props$createLinkProp = props.createLinkProp,
    createLinkProp = _props$createLinkProp === void 0 ? null : _props$createLinkProp,
    _props$headingType = props.headingType,
    Heading = _props$headingType === void 0 ? "h2" : _props$headingType;
  var _useState = useState(false),
    showAllMakes = _useState[0],
    setShowAllMakes = _useState[1];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var toggleAllMakes = function toggleAllMakes() {
    setShowAllMakes(!showAllMakes);
  };
  var hasShowMoreButton = cta && props.carMakesOrModelOrYears.length > 8;
  var createLink = createLinkProp ? createLinkProp : function (item) {
    var _props$selectedMake, _props$selectedMake$n, _props$selectedModel, _props$selectedModel$, _item$name_en;
    var makeSlug = (_props$selectedMake = props.selectedMake) === null || _props$selectedMake === void 0 ? void 0 : (_props$selectedMake$n = _props$selectedMake.name_en) === null || _props$selectedMake$n === void 0 ? void 0 : _props$selectedMake$n.slugify();
    var modelSlug = (_props$selectedModel = props.selectedModel) === null || _props$selectedModel === void 0 ? void 0 : (_props$selectedModel$ = _props$selectedModel.name_en) === null || _props$selectedModel$ === void 0 ? void 0 : _props$selectedModel$.slugify();
    var itemSlug = item === null || item === void 0 ? void 0 : (_item$name_en = item.name_en) === null || _item$name_en === void 0 ? void 0 : _item$name_en.slugify();
    var link = props.link_base_path;
    if (makeSlug) {
      link = link.replace("{make}", "/".concat(makeSlug));
    } else {
      link = link.replace("{make}", "");
    }
    if (modelSlug) {
      link = link.replace("{model}", "/".concat(modelSlug));
    } else {
      link = link.replace("{model}", "");
    }
    link = link.replace("{year}", "");
    return createUrl("".concat(link, "/").concat(itemSlug));
  };
  var printLabelInternal = function printLabelInternal(item) {
    if (props.printLabel) {
      return ucWords(props.printLabel(item));
    }
    return ucWords(item.name);
  };
  if (props !== null && props !== void 0 && props.selectedMake && (props === null || props === void 0 ? void 0 : (_props$models = props.models) === null || _props$models === void 0 ? void 0 : _props$models.length) === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "".concat(stl.brands_container, " ").concat(props !== null && props !== void 0 && props.showAsListOnMobile ? stl.CMSCarsContainer : undefined)
  }, /*#__PURE__*/React.createElement(Heading, {
    className: "container big"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.brands_makesContainer, " ").concat(stl.makesWithLogo, " ").concat(props !== null && props !== void 0 && props.showAsListOnMobile ? stl.showAsListOnMobile : undefined)
  }, props === null || props === void 0 ? void 0 : (_props$carMakesOrMode = props.carMakesOrModelOrYears) === null || _props$carMakesOrMode === void 0 ? void 0 : (_props$carMakesOrMode2 = _props$carMakesOrMode.slice(0, 8)) === null || _props$carMakesOrMode2 === void 0 ? void 0 : _props$carMakesOrMode2.map(function (make, idx) {
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: createLink(make),
      className: " ".concat(stl.singleLogoMake),
      "aria-label": make.name
    }, (make.icon_url || make.logo) && /*#__PURE__*/React.createElement("div", {
      className: stl.imgContainer
    }, /*#__PURE__*/React.createElement("img", {
      loading: "lazy",
      width: 90,
      height: 90,
      src: make.icon_url || make.logo,
      alt: make.name
    })), /*#__PURE__*/React.createElement("h3", {
      className: stl.makeName
    }, printLabelInternal(make)));
  }), props === null || props === void 0 ? void 0 : (_props$carMakesOrMode3 = props.carMakesOrModelOrYears) === null || _props$carMakesOrMode3 === void 0 ? void 0 : (_props$carMakesOrMode4 = _props$carMakesOrMode3.slice(8)) === null || _props$carMakesOrMode4 === void 0 ? void 0 : _props$carMakesOrMode4.map(function (make, idx) {
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: createLink(make),
      className: " ".concat(stl.singleLogoMake, " m-show"),
      "aria-label": make.name
    }, /*#__PURE__*/React.createElement("div", {
      className: stl.imgContainer
    }, /*#__PURE__*/React.createElement("img", {
      width: 90,
      height: 90,
      src: make.icon_url,
      alt: make.name
    })), /*#__PURE__*/React.createElement("h3", {
      className: stl.makeName
    }, printLabelInternal(make)));
  })), hasShowMoreButton && !showAllMakes && /*#__PURE__*/React.createElement(SubmitButton, {
    onClick: function onClick() {
      toggleAllMakes();
    },
    className: ["blueBtn", !(props !== null && props !== void 0 && props.showAsListOnMobile) ? "m-hide" : undefined, stl.viewAllMakes, stl.button].join(" "),
    type: "button",
    loading: false,
    disabled: false
  }, cta === null || cta === void 0 ? void 0 : cta.label), hasShowMoreButton && showAllMakes && /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.allCarsMakeText)
  }, /*#__PURE__*/React.createElement("h3", null, cta === null || cta === void 0 ? void 0 : cta.label), /*#__PURE__*/React.createElement("ul", null, props === null || props === void 0 ? void 0 : (_props$carMakesOrMode5 = props.carMakesOrModelOrYears) === null || _props$carMakesOrMode5 === void 0 ? void 0 : (_props$carMakesOrMode6 = _props$carMakesOrMode5.slice(8)) === null || _props$carMakesOrMode6 === void 0 ? void 0 : _props$carMakesOrMode6.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx
    }, /*#__PURE__*/React.createElement("a", {
      href: createLink(item)
    }, ucWords(item.name)));
  })))));
};
export default CarMakeContainer;